import PrimaryButton from '../buttons/PrimaryButton'
import React from 'react'
import SecondaryButton from '../buttons/SecondaryButton'
import Progress from './Progress'

const Course = ({
  id,
  title,
  description,
  status,
  progress,
  haveBg,
  isDetail,
  startCourse,
  loading,
  badges,
  disable = false,
  isEarned,
  partnerLogo
}) => {
  const renderStatus = () => {
    switch (status) {
      case '':
      default:
        return (
          <div className="flex flex-col gap-4 justify-start">
            <div>
              <div className="flex gap-4 flex-col md:flex-row justify-start">
                <p
                  className={`text-2xl ${disable ? 'text-grey-600' : 'text-primary'} font-bold`}
                >
                  {title}
                </p>
              </div>
              {partnerLogo && <span className="text-sm flex items-center gap-1">In partnership with <img className="h-3 w-auto" src={partnerLogo} alt="partner" /></span>}
            </div>
            <p
              className={`text-sm font-normal ${disable ? 'text-grey-600' : 'text-black'}`}
            >
              {description}
            </p>
            {isDetail ? (
              <PrimaryButton
                disabled={loading || disable}
                className="flex gap-2 w-fit"
                onClick={startCourse}
              >
                Start course
              </PrimaryButton>
            ) : (
              <PrimaryButton className="flex gap-2 w-fit" to={`/sources/${id}`}>
                See details
              </PrimaryButton>
            )}
          </div>
        )
      case 'in_progress':
        return (
          <div className="flex flex-col gap-4 justify-start">
            <div>
              <div className="flex gap-4 flex-col md:flex-row justify-start">
                <p className="text-2xl text-primary font-bold">{title}</p>
                <p className="mb-2 text-sm text-secondary-400 p-1 rounded-lg border border-secondary-400 bg-secondary-100 w-fit">
                  In progress
                </p>
              </div>
              {partnerLogo && <span className="text-sm flex items-center gap-1">In partnership with <img className="h-3 w-auto" src={partnerLogo} alt="partner" /></span>}
            </div>
            <p className="text-sm font-normal text-black">{description}</p>
            {isDetail ? (
              <></>
            ) : (
              <SecondaryButton
                className="flex gap-2 w-fit"
                to={`/sources/${id}`}
              >
                Continue
              </SecondaryButton>
            )}
          </div>
        )
      case 'completed':
        return (
          <div className="flex flex-col gap-4 justify-start">
            <div>
              <div className="flex gap-4 flex-col md:flex-row justify-start">
                <p className="text-2xl text-primary font-bold">{title}</p>
                <p className="mb-2 text-sm text-[#26BE74] p-1 rounded-lg border border-[#26BE74] bg-secondary-100 w-fit">
                  Completed
                </p>
              </div>
              {partnerLogo && <span className="text-sm flex items-center gap-1">In partnership with <img className="h-3 w-auto" src={partnerLogo} alt="partner" /></span>}
            </div>
            <p className="text-sm font-normal text-black">{description}</p>

            {isDetail ? (
              <></>
            ) : (
              <SecondaryButton
                className="flex gap-2 w-fit"
                to={`/sources/${id}`}
              >
                Review
              </SecondaryButton>
            )}
          </div>
        )
    }
  }

  const renderBadge = () => {
    if (badges && badges.length > 0) {
      return (
        <img
          src={badges[0].image_url}
          className={`${(disable || !isEarned) && 'opacity-50 grayscale'} max-w-40 float-end`}
          alt="rocket"
        />
      )
    }

    return (
      <img
        src="/images/course_default.png"
        className={`${(disable || !isEarned) && 'opacity-50 grayscale'} max-w-40 float-end`}
        alt="rocket"
      />
    )
  }

  return (
    <div
      className={`${haveBg && 'bg-primary-100'} flex flex-col-reverse ${isDetail ? 'md:flex-row-reverse' : 'md:flex-row'} items-center w-full rounded-lg overflow-hidden border ${disable ? 'border-grey-400' : 'border-primary'}`}
    >
      <div className="flex-grow p-4">{renderStatus()}</div>
      <div className="flex-shrink-0 h-full">{renderBadge()}</div>
    </div>
  )
}

export default Course
